// extracted by mini-css-extract-plugin
export var dismissOverlay = "_bi-b";
export var interactivePassthrough = "_bi-3";
export var modal = "_bi-d";
export var modalBackdrop = "_bi-c";
export var modalBody = "_bi-j";
export var modalDescription = "_bi-m";
export var modalEnter = "_bi-e";
export var modalFooter = "_bi-n";
export var modalHeaderText = "_bi-h";
export var modalIconCircle = "_bi-i";
export var modalIconHeader = "_bi-g";
export var modalImage = "_bi-f";
export var modalSectionLabel = "_bi-k";
export var modalTitle = "_bi-l";
export var pulse = "_bi-1";
export var pulseBorder = "_bi-2";
export var spotlight = "_bi-0";
export var tooltip = "_bi-4";
export var tooltipButtons = "_bi-9";
export var tooltipDescription = "_bi-6";
export var tooltipFooter = "_bi-7";
export var tooltipInteractivePill = "_bi-a";
export var tooltipStepIndicator = "_bi-8";
export var tooltipTitle = "_bi-5";